import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../lib/i18n";
import { TypeIcon, StatusPill } from "./work/workMeta";

export default function GlobalSearch() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    const h = setTimeout(() => api.get("/work/search", { params: { q } }).then((r) => { setResults(r.data); setOpen(true); }).catch(() => {}), 250);
    return () => clearTimeout(h);
  }, [q]);
  useEffect(() => {
    const onDoc = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const go = (item) => { navigate(`/work/${item.key}`); setOpen(false); setQ(""); };
  return (
    <div ref={box} className="relative hidden md:block" data-testid="global-search">
      <Search className="h-3.5 w-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <input data-testid="global-search-input" value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => results.length && setOpen(true)}
        onKeyDown={(e) => { if (e.key === "Enter" && results[0]) go(results[0]); if (e.key === "Escape") setOpen(false); }}
        placeholder={t("searchWork")} className="h-8 w-56 lg:w-72 rounded-md border bg-white pl-8 pr-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]/30" />
      {open && results.length > 0 && (
        <div className="absolute z-40 mt-1 w-[26rem] max-w-[90vw] bg-white border rounded-md shadow-lg overflow-hidden" data-testid="global-search-results">
          {results.map((r) => (
            <button key={r.id} type="button" data-testid={`search-result-${r.key}`} onClick={() => go(r)} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-secondary">
              <TypeIcon type={r.type} /><span className="text-xs text-muted-foreground w-16 shrink-0">{r.key}</span><span className="flex-1 truncate">{r.title}</span>
              <StatusPill name={r.status_name} category={r.status_category} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
